
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { useNavItemPathMatching } from '../hooks/useNavItemPathMatching';
import { NavItem } from '../types';

interface ChildNavItemProps { 
  child: NavItem['children'][0]; 
  handleNavigation: () => void;
}

const ChildNavItem: React.FC<ChildNavItemProps> = ({ 
  child, 
  handleNavigation 
}) => {
  const ChildIcon = child.icon;
  const location = useLocation();
  const isActive = useNavItemPathMatching(child.path, location.pathname);

  return (
    <NavLink
      key={child.path}
      to={child.path}
      className={({ isActive }) => cn(
        "flex items-center px-3 py-2 rounded-md transition-colors duration-200",
        isActive 
          ? "bg-primary/10 text-primary font-medium" 
          : "text-muted-foreground hover:bg-muted hover:text-foreground"
      )}
      onClick={handleNavigation}
      end={child.path === '/dashboard' || child.path === '/'}
    >
      {ChildIcon && <ChildIcon size={18} className="mr-3 flex-shrink-0" />}
      <span className="flex-1 text-left">{child.title}</span>
      {child.badge && (
        <Badge variant="default" className="ml-auto">{child.badge}</Badge>
      )}
    </NavLink>
  );
};

export default ChildNavItem;
